import { Injectable } from "@angular/core";


export interface IMediaOptions {
    mediaType: string;
    fileUrlPrefix: string;
    fileTypeIcon?: string
    openPopUp?: boolean
    category?: boolean
}
export class MediaOptions {
    constructor(
        public mediaType?: string,
        public fileUrlPrefix?: string,
        public fileTypeIcon?: string,
        public openPopUp?: boolean,
        public category?: boolean
    ) { }
}

export const file_download_options: any = {
    "pdf":  {fileTypeIcon: "pdf-icon", mediaType: "application/pdf", fileUrlPrefix: "content/pdf/"},
	"doc":  {fileTypeIcon: "doc-icon", mediaType: "application/msword", fileUrlPrefix: "content/pdf/"},
	"dot":  {fileTypeIcon: "doc-icon", mediaType: "application/msword", fileUrlPrefix: "content/pdf/"},
	"docx": {fileTypeIcon: "doc-icon", mediaType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", fileUrlPrefix: "content/pdf/"},
	"dotx": {fileTypeIcon: "doc-icon", mediaType: "application/vnd.openxmlformats-officedocument.wordprocessingml.template", fileUrlPrefix: "content/pdf/"},
	"docm": {fileTypeIcon: "doc-icon", mediaType: "application/vnd.ms-word.document.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"dotm": {fileTypeIcon: "doc-icon", mediaType: "application/vnd.ms-word.template.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"xls":  {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel", fileUrlPrefix: "content/pdf/"},
	"xlt":  {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel", fileUrlPrefix: "content/pdf/"},
	"xla":  {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel", fileUrlPrefix: "content/pdf/"},
	"xlsx": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", fileUrlPrefix: "content/pdf/"},
	"xltx": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.openxmlformats-officedocument.spreadsheetml.template", fileUrlPrefix: "content/pdf/"},
	"xlsm": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel.sheet.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"xltm": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel.template.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"xlam": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel.addin.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"xlsb": {fileTypeIcon: "xls-icon", mediaType: "application/vnd.ms-excel.sheet.binary.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"ppt":  {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint", fileUrlPrefix: "content/pdf/"},
	"pot":  {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint", fileUrlPrefix: "content/pdf/"},
	"pps":  {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint", fileUrlPrefix: "content/pdf/"},
	"ppa":  {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint", fileUrlPrefix: "content/pdf/"},
	"pptx": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.openxmlformats-officedocument.presentationml.presentation", fileUrlPrefix: "content/pdf/"},
	"potx": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.openxmlformats-officedocument.presentationml.template", fileUrlPrefix: "content/pdf/"},
	"ppsx": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.openxmlformats-officedocument.presentationml.slideshow", fileUrlPrefix: "content/pdf/"},
	"ppam": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint.addin.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"pptm": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint.presentation.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"potm": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint.template.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"ppsm": {fileTypeIcon: "ppt-icon", mediaType: "application/vnd.ms-powerpoint.slideshow.macroEnabled.12", fileUrlPrefix: "content/pdf/"},
	"jpg": {fileTypeIcon: "img-icon", fileUrlPrefix: "content/anotherfile/media/", openPopUp: true, category: "image"},
    "mail": {fileTypeIcon: "mail-icon", fileUrlPrefix: "", openPopUp: true, category: "mail"},
    "jfif": {fileTypeIcon: "img-icon", fileUrlPrefix: "content/anotherfile/media/", openPopUp: true, category: "image"},
    "png": {fileTypeIcon: "img-icon", fileUrlPrefix: "content/anotherfile/media/", openPopUp: true, category: "image"},
    "jpeg": {fileTypeIcon: "img-icon", fileUrlPrefix: "content/anotherfile/media/", openPopUp: true, category: "image"},
    "mp4": {fileTypeIcon: "", fileUrlPrefix: "content/anotherfile/media/", openPopUp: true, category: "Video"}
    
}

@Injectable({
    providedIn: "root"
})
export class FileUtilsService {
    fileDownloadOptions = new Map<string, IMediaOptions>();
    constructor() {
        Object.keys(file_download_options).forEach((mediaOptionKey:string)=>{
            const mediaOption: IMediaOptions = file_download_options[mediaOptionKey];
            this.fileDownloadOptions.set(mediaOptionKey, mediaOption);
        });
    }

    getFileTypeIcon(fileType: string | null | undefined) {
        if (fileType) {
            const mediaOptions = this.getFileOptions(fileType);
            if (mediaOptions?.fileTypeIcon) {
                return mediaOptions.fileTypeIcon;
            }
        }
        return `${fileType}-icon`;
    }

    getFileOptions(fileType: string): IMediaOptions | undefined {
        if (fileType) {
            return this.fileDownloadOptions.get(fileType.toLowerCase());
        }
        return undefined;
    }
}
